export const REPORT_PERMISSION_KEYS = {
  VIEW: "reports.view",
  ADVANCED: "reports.advanced",
  ASSIGNED_APPLICATION_DATA: "reports.view_assigned_application_data",
  EXPORT: "reports.export",
  CREATE: "reports.create",
} as const;

export type ReportDataScope = "none" | "all" | "assigned_application_data";

export interface ReportsAccessState {
  canViewReports: boolean;
  canViewAdvancedAnalytics: boolean;
  canCreateReports: boolean;
  canExportReports: boolean;
  canViewAssignedApplicationReports: boolean;
  reportDataScope: ReportDataScope;
  isChartOnlyMode: boolean;
}

export function resolveReportsAccess(
  permissionKeys: Iterable<string>,
): ReportsAccessState {
  const grantedPermissions = new Set(permissionKeys);
  const canViewReports = grantedPermissions.has(REPORT_PERMISSION_KEYS.VIEW);

  const hasAdvancedAnalyticsPermission = grantedPermissions.has(
    REPORT_PERMISSION_KEYS.ADVANCED,
  );
  const hasGlobalApplicationDataAccess =
    grantedPermissions.has("applications.view_all") ||
    grantedPermissions.has("cape.view");
  const canViewAssignedApplicationReports =
    canViewReports &&
    grantedPermissions.has(REPORT_PERMISSION_KEYS.ASSIGNED_APPLICATION_DATA);

  const canViewAdvancedAnalytics =
    canViewReports && hasAdvancedAnalyticsPermission;
  const canCreateReports =
    (canViewAdvancedAnalytics || canViewAssignedApplicationReports) &&
    grantedPermissions.has(REPORT_PERMISSION_KEYS.CREATE);
  const canExportReports =
    canViewAdvancedAnalytics &&
    grantedPermissions.has(REPORT_PERMISSION_KEYS.EXPORT);
  const reportDataScope: ReportDataScope = !canViewReports
    ? "none"
    : canViewAssignedApplicationReports && !hasGlobalApplicationDataAccess
      ? "assigned_application_data"
      : "all";

  return {
    canViewReports,
    canViewAdvancedAnalytics,
    canCreateReports,
    canExportReports,
    canViewAssignedApplicationReports,
    reportDataScope,
    isChartOnlyMode: canViewReports && !canViewAdvancedAnalytics,
  };
}
